<template>
  <div>
    <b-row>
      <b-col class="col-title" cols="2">
        <h4 class="title-options">Edad:</h4>
      </b-col>
      <b-col cols="10">
        <RadioButtons />
      </b-col>
    </b-row>

    <b-row>
      <b-col class="col-title" cols="2">
        <h4 class="title-options">Genero:</h4>
      </b-col>
      <b-col cols="10">
        <GeneroButtons />
      </b-col>
    </b-row>

    <b-row>
      <b-col class="col-title" cols="2">
        <h4 class="title-options">Tipo de contrato:</h4>
      </b-col>
      <b-col cols="10">
        <Contrato />
      </b-col>
    </b-row>

    <b-row>
      <b-col class="col-title" cols="2">
        <h4 class="title-options">Estamento:</h4>
      </b-col>
      <b-col cols="10">
        <Estamento />
      </b-col>
    </b-row>

    <b-row>
      <b-col class="col-title" cols="2">
        <h4 class="title-options">Permanencia en el servicio:</h4>
      </b-col>
      <b-col cols="10">
        <Permanencia />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import RadioButtons from "./buttons/RadioButtons.vue";
import GeneroButtons from "./buttons/GeneroButtons.vue";
import Contrato from "./buttons/Contrato.vue";
import Estamento from "./buttons/Estamento.vue";
import Permanencia from "./buttons/Permanencia.vue";
export default {
  components: {
    RadioButtons,
    GeneroButtons,
    Contrato,
    Estamento,
    Permanencia,
  },
};
</script>

<style scoped>
.row {
  margin: 0;
  margin-top: 20px;
}

.col-title {
  display: grid;
  justify-content: center;
  align-items: center;
}

.title-options {
  font-size: 25px;
  font-weight: 600;
  text-align: center;
}

@media screen and (max-width: 1600px) {
  .title-options {
    font-size: 20px;
    font-weight: 600;
  }
}

@media screen and (max-width: 1600px) {
  .title-options {
    font-size: 16px;
    font-weight: 600;
  }
}

@media screen and (max-width: 1000px) {
  .title-options {
    font-size: 12px;
    font-weight: 600;
  }
}

@media screen and (max-width: 662px) {
  .title-options {
    font-size: 10px;
    font-weight: 600;
  }
}
</style>
